import { type TranslationTree } from '@/i18n/types';

export const messages = {
  startDate: 'Data',
  startTime: 'Horário de início',
  optional: 'opcional',
  recurrence: 'Repetição',
  recurrenceHint:
    'Um evento que se repete aparece no app em cada data. Mudar a repetição depois remove as confirmações das datas que deixarem de existir.',
  noRepeat: 'Não se repete',
  frequency: {
    daily: 'Todo dia',
    weekly: 'Toda semana',
    monthly: 'Todo mês, no mesmo dia',
  },
  weekdays: 'Dias da semana',
  weekdaysHint: 'Sem nenhum dia marcado, repete no mesmo dia da semana da data de início.',
  until: 'Repetir até',
  untilHint: 'Sem data final, o app mostra as datas dos próximos 12 meses.',
} satisfies TranslationTree;
